/** Title line above body lines: the shape a titled section loads into. */

import { Pad } from 'component/basics';
import { spacings } from 'component/constants';
import { Fragment } from 'react';
import type { DimensionValue } from 'react-native';
import { View } from 'react-native';

import { TextContainerSkeleton } from './text-container-skeleton';

type TextLinesSkeletonProps = { lines?: number; lastLineWidth?: DimensionValue };

// Paragraph placeholder. The last line is rendered short to mimic a real
// paragraph's ragged final line.
function TextLinesSkeleton({ lines = 3, lastLineWidth = 140 }: TextLinesSkeletonProps) {
    return (
        <View>
            {Array.from({ length: lines }).map((_, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <Fragment key={i}>
                    {i > 0 && <Pad size={12} />}
                    <TextContainerSkeleton borderRadius={2} height={6} width={i === lines - 1 ? lastLineWidth : undefined} />
                </Fragment>
            ))}
        </View>
    );
}

// Title line above a block of body lines — the shape almost every titled
// section collapses to while it loads.
export function TitledSectionSkeleton({ lines = 3, titleWidth = 140 }: { lines?: number; titleWidth?: DimensionValue }) {
    return (
        <View>
            <TextContainerSkeleton borderRadius={2} height={8} width={titleWidth} />
            <Pad size={spacings.xl2} />
            <TextLinesSkeleton lines={lines} />
        </View>
    );
}
